import { makeStyles } from '@material-ui/core/styles';

export default makeStyles((theme) => ({
    content:{
        display:"flex",
        justifyContent:"center",
        alignItems:"center",       
        
    }

}))